import {types} from '../types/types'; 
const userData = JSON.parse(localStorage.getItem('userDataKidkiriki'));
const deviceToken = JSON.parse(localStorage.getItem('notificationKidkiriki'));

const initialState = {
    token: userData ? userData : '',  
    device_token: deviceToken ? deviceToken?.[0]?.token : '',
    isLogin: userData ? true : false, 
}; 

export const authReducer = ( state = initialState, action ) => {
    
    switch (action.type) {
        case types.login:
            return { 
                token: action.payload.token,
                device_token: action.payload.device_token,
                isLogin: action.payload.isLogin
            } 

        case types.logout:
            return { }
    
        default:
            return state;
    }
};